<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00076.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 0,
          label: 'P00076.card.state.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-danger',
        },
        {
          ref: 1,
          label: 'P00076.card.state.regul' | translate,
          icon: 'fa-kit fa-picto-programme',
          color: 'color-green',
        },
      ]"
      [value]="this.actionStack!.getValue('coCModeFonctionnement')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Control,
          'coCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00076.controle.niveaux' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3 pt-3">
    <div #slider class="nouislider-container"></div>
  </div>
</div>
